import React, { Component } from 'react';

const getCellIndex = cell => {
  const children = cell.parentNode.childNodes;
  let i,
    len = children.length;

  for (i = 0; i < len; ) {
    if (children[i] === cell) {
      break;
    }

    i++;
  }

  return i;
};

class TableHover extends Component {
  constructor(props) {
    super(props);
    this.$el = React.createRef();
  }

  componentDidMount() {
    this.$el.current.addEventListener('mouseover', this.addColumnHighlighting);
    this.$el.current.addEventListener('mouseout', this.removeColumnHighlighting);
  }

  componentWillUnmount() {
    this.$el.current.removeEventListener('mouseover', this.addColumnHighlighting);
    this.$el.current.removeEventListener('mouseout', this.removeColumnHighlighting);
  }

  addColumnHighlighting = ({ target }) => {
    const { current: table } = this.$el;
    const cell = target.tagName.toLowerCase() === 'td' ? target : target.closest('td');

    if (cell) {
      const cellIndex = getCellIndex(cell);
      const rows = table.getElementsByTagName('tr');

      [].forEach.call(rows, row => {
        const cells = row.getElementsByTagName('td');
        let i,
          len = cells.length;

        for (i = 0; i < len; i++) {
          if (cells[i]) {
            cells[i].classList.toggle('hovered', i === cellIndex);
          }
        }
      });
    }
  };

  removeColumnHighlighting = () => {
    const { current: table } = this.$el;
    const cells = table.getElementsByTagName('td');

    [].forEach.call(cells, cell => {
      cell.classList.remove('hovered');
    });
  };

  render() {
    const { children, ...rest } = this.props;

    return (
      <table ref={this.$el} {...rest}>
        {children}
      </table>
    );
  }
}

export default TableHover;
